<template>
  <hm-content title="订单列表">
    <div class="table-panel flex item-center">
      <el-date-picker
        v-model="dateAndTime"
        type="daterange"
        align="right"
        start-placeholder="开始时间"
        end-placeholder="结束时间"
        size="small"
        class="mr10"
      ></el-date-picker>
      <el-select
        clearable
        v-model="callType"
        placeholder="取号方式"
        size="small"
        filterable
        class="mr10"
      >
        <el-option label="预约取号" value="0"></el-option>
        <el-option label="现场取号" value="1"></el-option>
      </el-select>
      <el-select
        clearable
        v-model="status"
        placeholder="叫号状态"
        size="small"
        filterable
        class="mr10"
      >
        <el-option label="等待中" value="0"></el-option>
        <el-option label="服务中" value="1"></el-option>
        <el-option label="完成" value="2"></el-option>
        <el-option label="过号" value="3"></el-option>
      </el-select>
      <el-input
        clearable
        v-model.trim="keyWord"
        placeholder="输入客户姓名/手机号"
        size="small"
        class="ipt mr10"
      ></el-input>
      <el-button type="primary" size="small" @click="search">查询</el-button>
    </div>
    <div class="table">
      <el-table
        stripe
        border
        :data="getNumRecordList.list"
        style="width: 100%"
        id="table"
        size="small"
      >
        <el-table-column type="index" width="50" label="序号"></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="number"
          label="号码"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="memberName"
          label="客户名称"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="mobilePhone"
          label="联系电话"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="serverName"
          label="服务"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="guiderName"
          label="技师"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="callTypeFormat"
          label="取号方式"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="getNumTimeFormat"
          width="140px"
          label="取号时间"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="callNumTimeFormat"
          width="140px"
          label="叫号时间"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="statusFormat"
          label="叫号状态"
        ></el-table-column>
      </el-table>
    </div>
    <div class="hm-pagination">
      <el-pagination
        background
        :total="getNumRecordList.total"
        @current-change="paging"
        @size-change="handleSizeChange"
        layout="total,sizes,   prev, pager, next, jumper"
        :current-page="currentPage"
      ></el-pagination>
    </div>
  </hm-content>
</template>

<script>
import axios from "axios";

import moment from "moment";
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      dialogVisible: false,
      currentId: "",
      total: 100,
      currentPage: 1,
      pageSize: 10,
      orderId: "",
      realName: "",
      serverId: "",
      dateAndTime: "",
      startDate: "",
      endDate: "",
      callType: "",
      status: "",
      keyWord: ""
    };
  },
  mounted() {
    this.queryList();
  },
  computed: mapGetters(["orderDetail", "getNumRecordList"]),
  watch: {
    dateAndTime(val) {
      this.startDate = val ? moment(val[0]).format("YYYY-MM-DD") : "";
      this.endDate = val ? moment(val[1]).format("YYYY-MM-DD") : "";
    }
  },
  methods: {
    paging(page) {
      this.currentPage = page;
      this.queryList();
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.queryList();
    },
    queryList() {
      this.$store.dispatch("queryGetNumRecordList", {
        keyWord: this.keyWord,
        callType: this.callType,
        status: this.status,
        startDate: this.startDate,
        endDate: this.endDate,
        pageNo: this.currentPage,
        pageSize: this.pageSize
      });
    },
    search() {
      this.currentPage = 1;
      this.queryList();
    },
    back() {
      this.dialogVisible = false;
    },
    output() {
      axios({
        method: "post",
        url: `/server-back/order_export`,
        data: {
          orderId: this.orderId,
          realName: this.realName,
          serverId: this.serverId,
          startDate: this.startDate,
          endDate: this.endDate
        },
        responseType: "arraybuffer"
      }).then(res => {
        this.download(res.data);
      });
      // axios.post(`${adress}/server-back/order_export`, {});
      // this.$store.dispatch("outputOrder", {
      //   orderId: this.orderId,
      //   realName: this.realName,
      //   serverId: this.serverId,
      //   startDate: this.startDate,
      //   endDate: this.endDate
      // });
    },
    download(data) {
      if (!data) {
        return;
      }
      let url = window.URL.createObjectURL(new Blob([data]));
      let link = document.createElement("a");
      link.style.display = "none";
      link.href = url;
      link.setAttribute("download", "订单列表.xlsx");
      document.body.appendChild(link);
      link.click();
    }
  }
};
</script>

<style scoped lang="scss">
.order-detail-list {
  li {
    margin-bottom: 30px;
    font-size: 14px;
  }
  .title {
    font-size: 16px;
    margin: 0;
    margin-bottom: 10px;
  }
  .item {
    line-height: 28px;
    span {
      color: #999;
    }
  }
  .order-table {
    border: 1px solid #ebebeb;
    margin-top: 12px;
    max-width: 500px;
    .order-header {
      border-bottom: 1px solid #ebebeb;
      background: #f5f7fa;
    }
    span {
      padding: 12px;
      width: 25%;
      text-align: center;
      border-right: 1px solid #ebebeb;
    }
    span:last-child {
      border-right: none;
    }
  }
}
</style>
